/* import __COLOCATED_TEMPLATE__ from './header-with-back-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();